import React, { Component } from 'react';

class Read extends Component {
  render() {
    return (
        <div>
            <header className="w3-container">
                <h5><b> Correo</b></h5>
            </header>
            <div className="w3-container person">
                <br />
                <img className="w3-round w3-animate-top" alt='' src="https://www.w3schools.com/w3images/avatar5.png" style={{width:'20%'}} />
                <h5 className="w3-opacity">Subject: None</h5>
                <h4><i className="fa fa-clock-o"></i> From Jane Doe, Sep 25, 2015.</h4>
                <a className="w3-button w3-blue">Reply<i className="w3-margin-left fa fa-mail-reply"></i></a>
                <a className="w3-button w3-blue w3-margin-left">Forward<i className="w3-margin-left fa fa-arrow-right"></i></a>
                <hr />
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
                    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                     Ut enim ad minim veniam, quis nostrud exercitation ullamco
                      laboris nisi ut aliquip ex ea commodo consequat. Excepteur 
                      sint occaecat cupidatat non proident, sunt in culpa qui officia
                       deserunt mollit anim id est laborum consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                         Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
                          nisi ut aliquip ex ea commodo consequat.</p>
                <p>Forever yours,<br/>Jane</p>
            </div>
        </div>
    );
  }
}

export default Read;


// WEBPACK FOOTER //
// ./src/Correo/Read.js